import React from 'react'

import logo from '../image/logo.jpg';

const Header = () => {
    return (
        <div>
            <header>

                    <h1>Scribbling Pens</h1>
            </header>
        </div>
    )
}

export default Header
